import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#f5f1eb] border-t border-black/5 mt-24">
      {/* 🔥 TOP BANNER */}
      <div className="container-px py-14">
        <div className="rounded-2xl bg-gradient-to-r from-[#1e293b] to-[#0f172a] text-white p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="max-w-xl">
            <h3 className="text-2xl md:text-3xl font-semibold leading-snug">
              Explore the Oswal Professional Network
            </h3>
            <p className="text-white/70 mt-3 text-sm md:text-base">
              Discover professionals, connect meaningfully, and be part of a
              growing community.
            </p>
          </div>

          <Link
            to="/membership"
            className="px-6 py-3 bg-orange-600 hover:bg-orange-700 rounded-full text-white font-medium transition whitespace-nowrap"
          >
            Apply for Membership
          </Link>
        </div>
      </div>

      {/* 🔻 MAIN FOOTER */}
      <div className="container-px py-16 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 xl:grid-cols-[1.2fr_1fr_1fr_1.8fr] gap-16">
        {/* LEFT */}
        <div>
          <div className="text-xl font-semibold text-black">Oswal Sabha</div>
          <div className="text-sm text-gray-700 tracking-wide">
            Professional Forum
          </div>

          <p className="mt-5 text-gray-600 text-sm leading-relaxed max-w-sm">
            A curated network of Oswal professionals across India and beyond,
            fostering collaboration, growth, and community impact.
          </p>
        </div>

        {/* CENTER */}
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-600 mb-5">
            Explore
          </div>

          <div className="flex flex-col gap-3 text-gray-700 text-sm">
            <Link to="/about" className="hover:text-black">
              About
            </Link>
            <Link to="/activities" className="hover:text-black">
              Activities
            </Link>
            <Link to="/team" className="hover:text-black">
              Team
            </Link>
            <Link to="/directory" className="hover:text-black">
              Directory
            </Link>
            <Link to="/membership" className="hover:text-black">
              Become a Member
            </Link>
          </div>
        </div>

        {/* RIGHT */}
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-600 mb-5">
            Connect
          </div>

          <div className="flex flex-col gap-3 text-gray-700 text-sm">
            <Link to="/contact" className="hover:text-black">
              Contact
            </Link>
            <a
              href="tel:+919414156086"
              className="inline-flex w-fit items-center rounded-full border border-black/10 px-4 py-2 text-sm font-medium text-black hover:bg-black/5 transition"
            >
              Call now
            </a>
          </div>
        </div>

        {/* MAP */}
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-600 mb-5">
            Find us
          </div>

          <div className="overflow-hidden rounded-2xl border border-black/10 bg-white shadow-sm">
            <div className="px-4 pt-4 pb-3 border-b border-black/5">
              <div className="text-sm font-semibold text-black">
                Oswal Bhawan, Mukherji Chowk
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Udaipur 313001, Rajasthan
              </div>
            </div>

            <div className="aspect-[4/3] w-full bg-gray-100">
              <iframe
                title="Oswal Sabha Professional Forum location map"
                src="https://www.google.com/maps?q=Oswal%20Bhawan%2C%20Mukherji%20Chowk%2C%20Udaipur%20313001&output=embed"
                className="h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <span className="text-xs text-gray-500">
                Tap to open in Google Maps
              </span>
              <a
                href="https://www.google.com/maps?q=Oswal%20Bhawan%2C%20Mukherji%20Chowk%2C%20Udaipur%20313001"
                target="_blank"
                rel="noreferrer"
                className="text-xs font-medium text-orange-600 hover:text-orange-700"
              >
                Open maps →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 🔥 BRAND */}
      <div className="border-t border-black/5 pt-8 pb-6 container-px flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <div className="text-base md:text-lg font-semibold text-black">
            Developed by Gauransh Jaroli
          </div>

          <div className="text-sm text-gray-600 mt-1">
            ParshWebCraft — Websites • SaaS • Automation Systems
          </div>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://parshwebcraft.in"
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-full border border-black/10 text-sm hover:bg-black/5 transition"
          >
            🌐 Website
          </a>

          <a
            href="https://wa.me/919414156086?text=Hello%20Oswal%20Sabha%20Professional%20Forum,%20I%20need%20help%20with%20membership,%20activities,%20or%20admin%20support."
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-full bg-green-600 text-white text-sm hover:bg-green-700 transition"
          >
            💬 WhatsApp
          </a>
        </div>
      </div>

      {/* COPYRIGHT & LEGAL */}
      <div className="border-t border-black/5 pt-6 pb-8 container-px flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
        <div>
          © 2026 Oswal Sabha Professional Forum. All rights reserved.
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
          <Link to="/privacy-policy" className="hover:text-black transition">Privacy Policy</Link>
          <Link to="/terms-conditions" className="hover:text-black transition">Terms & Conditions</Link>
          <Link to="/refund-policy" className="hover:text-black transition">Refund Policy</Link>
          <Link to="/disclaimer" className="hover:text-black transition">Disclaimer</Link>
        </div>
      </div>
    </footer>
  );
}
